<template>
    <div>
       
        <div style="padding: 10px;">
            <van-card v-for="item,index in clientlist" :key="index">
                <template #title>
                    <div v-if="name=='客户'" class="title">{{item.KHMC }}</div>
                    <div v-if="name=='商机'" class="title">{{item.SJMC }}</div>
                    <div v-if="name=='渠道'" class="title">{{item.NAME }}</div>
                    <div v-if="name=='面访记录'" class="title">{{item.subject}}</div>
                </template>
                <template #tags>
                    <div class="desc">
                    <div v-if="name=='面访记录'" >拜访对象 ：{{ item.client }}</div>
                    <div v-if="name=='面访记录'">拜访时间 ：{{ item.create_time }}</div>
                    <div v-if="name=='面访记录'">拜访地址 ：{{ item.location_title }}</div>
                    <div v-if="name=='面访记录'">参与拜访人员 ：{{ item.visiting_personnel }}</div>
                    
                    <div v-if="name=='渠道'"> CRM渠道编码：{{ item.CRMCODE }}</div>
                    <div v-if="name=='渠道'"> 类别：{{ item.CHANNELCATEGORY }}</div>
                    <div v-if="name=='渠道'"> 关系定位：{{ item.DETAILEDADDRESS }}</div>
                    <div v-if="name=='渠道'"> 合作状态：{{ item.COOPERATIONSTATUS }}</div>
                    <div v-if="name=='商机'">商机阶段：{{ item.STAGE }}</div>
                    <div v-if="name!=='渠道'" >CRM客户编码：{{ item.ID||item.crm_customer_code}}</div>
                    <div v-if="name=='客户'">土地规模(亩)：{{ item.LANDSCALE }}</div>
                    <div v-if="name=='客户'">用户ID：{{ item.USERID }}</div>
                    <div v-if="name!=='面访记录'&&name!=='渠道'"> 首次创建联系人：{{ item.FIRSTCREATIONCONTACT||item.NAME}}</div>
                    <div v-if="name!=='面访记录'&&name!=='渠道'"> 首次创建联系手机：{{ item.FIRSTCREATIONMOBILEPHONE||item.MOBILEPHONENUM }}</div>
                </div>
                </template>
                <template #footer>
                    <van-button @click="onClickcheckin(item)"  v-if="name!=='面访记录'" color="#FBAC01" size="small">面访签到</van-button>
                    <van-button @click="onClickchecklog(item)"  v-if="name=='面访记录'" color="#FBAC01" size="small">查看详情</van-button>
                </template>
            </van-card>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: '',
        },
        clientlist: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            value: '',
        };
    },
    methods:{
        onClickcheckin(obj) {
            console.log(obj);
            obj.visiting_source  = this.name =='出差申请'?'出差申请':'事件'
            obj.type = this.name =='客户'?1:this.name =='商机'?2:this.name =='渠道'?3:3
            // return
            this.$router.push({path:'/qiwei/keleshou/checkin',query:obj})
        },
        onClickchecklog(obj) {
            var parm = {
                crm_user_id:obj.crm_user_id,
                getSignInDetails:obj.id
            }
            this.$router.push({path:'/qiwei/keleshou/interviewinginfo',query:parm})
        },
    }
}
</script>

<style>
.title{
    font-size: 14px;
    font-weight: 600;
    margin-top: 10px;
}
.desc{
    font-size: 12px;
    color: #aeaeae;
}
.desc div{
    padding-top:  5px; ;
}
</style>


// WEBPACK FOOTER //
// src/pages/qiwei/keleshou/component/kuhuList.vue